module.exports = __webpack_public_path__ + "img/laugh-beam.c6705f8b.svg";